import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicList = _resolveComponent("DynamicList")!

  return (_openBlock(), _createBlock(_component_DynamicList, _normalizeProps(_guardReactiveProps(_ctx.request)), null, 16))
}